import { Chip, useTheme, alpha } from '@mui/material';

import { ArrowDownwardIcon, ArrowUpwardIcon } from '@occc-app/design-system';

type DeltaChip = {
  value: number;
};

export const DeltaChip = ({ value }: DeltaChip) => {
  const theme = useTheme();
  const isPositive = value >= 0;

  const baseColor = isPositive ? theme.palette.success.main : theme.palette.error.main;
  const icon = isPositive ? (
    <ArrowUpwardIcon fontSize='small' />
  ) : (
    <ArrowDownwardIcon fontSize='small' />
  );

  const bgColor = alpha(baseColor, 0.25);

  return (
    <Chip
      label={`${Math.abs(value)}%`}
      size='small'
      icon={icon}
      sx={{
        ml: 1,
        bgcolor: bgColor,
        color: theme.palette.text.primary,
        ...theme.typography.subtitle2,
      }}
    />
  );
};
